module.exports = __webpack_public_path__ + "img/ios-red.7387e13.svg";